import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { HttpClientService } from '../../../core/services/http-client.service';
import type { FiltersClient } from '../../../core/tokens/filters-client.token';
import { FILTERS } from '../../../shared/constants/api-routes.constants';
import type { IFilterResponse } from '../../../shared/components/filter-bar/models/filter.model';
import { DEFAULT_SERVICE_DEPARTMENTS } from '../constants/service-departments.constants';

@Injectable({ providedIn: 'root' })
export class FiltersService implements FiltersClient {
  private readonly http = inject(HttpClientService);

  getFilters(organizationId: string): Observable<IFilterResponse> {
    return this.http.get<IFilterResponse>(FILTERS.BASE, { params: { organizationId } }).pipe(
      map((response) => ({
        ...response,
        // Fall back to the default list until the backend implements this query.
        serviceDepartment: response.serviceDepartment?.length
          ? response.serviceDepartment
          : DEFAULT_SERVICE_DEPARTMENTS,
      }))
    );
  }
}
